/**
 * Media queries for useMediaQuery hook and CSS-in-JS usage
 *
 * @example
 * ```tsx
 * // For useMediaQuery hook (recommended)
 * const isDesktop = useMediaQuery(Breakpoints.mediumDeviceAndUp);
 *
 * // For CSS-in-JS
 * <div css={{
 *   [Breakpoints.smallDeviceAndUp]: {
 *     display: "block",
 *   },
 *   [Breakpoints.mediumDeviceAndUp]: {
 *     display: "block",
 *   },
 * }}>
 * ```
 */
export const Breakpoints = {
  // Small Device and Up
  smallDeviceAndUp: "@media (min-width: 415px)",
  // Medium Device and Up
  mediumDeviceAndUp: "@media (min-width: 900px)",
};
